import { createAdCampaign, deletAdCampaign, getAdCampaigns } from '@entities/ad-campaign/api'
import type { AdCampaignType } from '@entities/ad-campaign/api/types'
import { getErrorMessage } from '@shared/lib/errors'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import type { AdCampaign } from '../types'

export const useAdCampaigns = ({
    channelId,
    type
}: {
    channelId?: number
    type?: AdCampaignType
} = {}) => {
    const queryClient = useQueryClient()

    const queryKey = ['ad-campaigns', type, channelId]

    const adCampaigns = useQuery({
        queryKey,
        queryFn: () => getAdCampaigns(type, channelId),
        enabled: !!channelId && !!type
    })

    const { message } = App.useApp()

    const createAdCampaignMutation = useMutation({
        mutationFn: createAdCampaign,
        onSuccess: (data) => {
            message.success('Рекламная кампания создана')

            queryClient.invalidateQueries({
                queryKey: ['ad-campaigns'],
                exact: false
            })
        },
        onError: (error) => message.error(getErrorMessage(error))
    })

    // const editAdCampaignMutation = useMutation({
    //     mutationFn: editAdCampaign,
    //     onSuccess: (data) => {
    //         queryClient.setQueryData(['ad-campaigns', data.id], data)
    //         message.success('Рекламная компания изменена')
    //     }
    // })

    const deleteAdCampaignMutation = useMutation({
        mutationFn: deletAdCampaign,
        onSuccess: (data, variables) => {
            const previousItems: AdCampaign[] = queryClient.getQueryData(queryKey) ?? []
            const updatedItems = previousItems.filter((item) => item.id !== variables.id)
            queryClient.setQueryData(queryKey, updatedItems)
            message.success('Рекламная компания удалена')
        }
    })

    return {
        adCampaigns: adCampaigns.data,
        isLoading: adCampaigns.isPending,
        actions: {
            createAdCampaign: createAdCampaignMutation.mutateAsync,
            // editAdCampaign: editAdCampaignMutation.mutate,
            deleteAdCampaign: deleteAdCampaignMutation.mutate,
            refetchAdCampaigns: adCampaigns.refetch
        }
    }
}
